const defaultState = {
    pageSuccess: false, message: null
}
const RESET_PAGE = "RESET_PAGE"
export const resetPage = (payload) => ({type: RESET_PAGE, payload})
const SHOW_PAGE = "SHOW_PAGE"
export const showPage = (payload) => ({type: SHOW_PAGE, payload})
const Main_reducer = (state = defaultState, action) => {
    switch (action.type) {
        case RESET_PAGE:
            return {
                ...state, pageSuccess: false, message: null
            }
        case SHOW_PAGE:
            return {
                ...state, pageSuccess: true, message: action.payload,
            }
        default:
            return state;

    }
}


export const getSuccess = state => state.Main_reducer.pageSuccess
export const getMessage = state => state.Main_reducer.message

export default Main_reducer;
